const destinations = [
  {
    name: "United Kingdom",
    context: "London board meetings for Cool Springs executives, MARS Petcare UK operations, Tractor Supply supplier visits to British partners",
    urgency: "Corporate travel bookings often happen with 7–14 days lead time after a meeting is confirmed",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Mexico & Caribbean",
    context: "Cancún and Los Cabos family vacations, Jamaica and Bahamas cruises, Riviera Maya resort bookings from Williamson County families",
    urgency: "Last-minute resort deals and cruise bookings from Spring Hill and Thompson's Station create compressed timelines",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Germany & France",
    context: "CHS and healthcare industry conferences in Berlin, Paris luxury travel, automotive industry meetings, Oktoberfest trips",
    urgency: "Conference registration often precedes travel booking by months, but passport renewal is forgotten until the flight approaches",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Canada",
    context: "Toronto business connections, Vancouver family trips, NHL hockey away games, summer lake vacations in Ontario and Quebec",
    urgency: "Summer family road trips and last-minute sports travel peak June through August",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Italy & Spain",
    context: "European summer vacations for Brentwood and Franklin families, art and cultural tours, wine country travel, Mediterranean cruises",
    urgency: "Summer European bookings often happen in January/February — passports expire without notice during the booking window",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Costa Rica & Peru",
    context: "Adventure travel from Williamson County's active, outdoor-oriented demographic, eco-tourism, Machu Picchu expeditions",
    urgency: "Adventure travel packages often book 60–90 days out, but passport renewal is often overlooked until closer to departure",
    icon: "ri-map-pin-2-line",
  },
];

const stats = [
  {
    stat: "Top 10",
    label: "Williamson County is consistently ranked among the top 10 wealthiest counties in the United States — translating directly into high international travel rates",
  },
  {
    stat: "2–3 Weeks",
    label: "average notice Franklin corporate travelers have between a confirmed international meeting and their departure date",
  },
  {
    stat: "June–Aug",
    label: "peak season when Williamson County family vacations, European summer trips, and Caribbean cruises all collide simultaneously",
  },
  {
    stat: "20 Miles",
    label: "from Franklin to BNA Nashville International Airport — quick access to direct international flights that demand a valid passport",
  },
];

export default function FranklinTNDestinationsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Travel Intelligence</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Franklin, TN Travelers Go — And Why Passports Get Urgent
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            These are the destinations and travel patterns we see most from Williamson County clients. Understanding local travel behavior is part of why our document review catches issues before they derail your corporate trip, family cruise, or European vacation.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-14">
          {stats.map((s, i) => (
            <div key={i} className="bg-[#1A365D] rounded-lg p-6 text-center">
              <p className="font-serif text-3xl font-bold text-[#F6C344] mb-2">{s.stat}</p>
              <p className="text-white/60 text-xs leading-relaxed">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {destinations.map((d, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200 hover:border-[#F6C344] transition-all group">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D]/5 group-hover:bg-[#F6C344]/15 transition-colors flex-shrink-0">
                  <i className={`${d.icon} text-[#1A365D] group-hover:text-[#F6C344] transition-colors text-lg`}></i>
                </div>
                <div>
                  <h3 className="font-bold text-[#1A365D] text-sm">{d.name}</h3>
                </div>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-3">{d.context}</p>
              <div className="flex items-start gap-2">
                <i className="ri-time-line text-[#F6C344] text-xs flex-shrink-0 mt-0.5"></i>
                <p className="text-gray-400 text-xs leading-relaxed italic">{d.urgency}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
              <i className="ri-links-line text-[#1A365D] text-xl"></i>
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-[#1A365D] text-sm mb-1">Explore Other Tennessee Service Areas</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                We serve travelers across Tennessee with the same expedited passport processing and document review expertise. Looking for service in another community?
              </p>
            </div>
            <div className="flex flex-wrap gap-2 flex-shrink-0">
              <a href="/cities/nashville" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Nashville <i className="ri-arrow-right-line text-xs"></i>
              </a>
              <a href="/cities/murfreesboro" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Murfreesboro <i className="ri-arrow-right-line text-xs"></i>
              </a>
              <a href="/cities/clarksville" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Clarksville <i className="ri-arrow-right-line text-xs"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}